import { logError } from '@/features/shared/utils/logger'
import { useEffect } from 'react'
import { datadogRum } from '@datadog/browser-rum'
import { useFeatureFlags } from '@/features/shared/services/FeatureFlags/useFeatureFlags'

export const useSyncFeatureFlagsWithGlobalVariable = () => {
  const { flags, status } = useFeatureFlags()

  useEffect(() => {
    if (status !== 'pending') {
      try {
        Object.entries(flags).forEach(([key, value]) => {
          datadogRum.addFeatureFlagEvaluation(`ff_${key}`, value)
        })
      } catch (e) {
        // dont wanna accidentally bring down the app, need alerting around this error
        logError(
          new Error('Unable to set feature flag global variables', {
            cause: e,
          }),
        )
      }
    }
  }, [status, flags])
}
